import React, { useState, useEffect } from 'react';
import moment from "moment";
import { FormGroup, Button, Loader, Alert } from 'arag-ui-lib';
import { requestBrokerFirmsFiltered } from '../../actions/brokerFirms'
import { useDispatch, useSelector } from 'react-redux';
const Broker = (props) => {
    const {
        broker, handleSubmit, formErrors, loading, cancelSubmit, brokerFirms,
        changeBroker, formSuccessMsg, fetchingBroker, generalError, onUnlockBroker,
        unlockErrorMessage,unlockingUser
    } = props;

    const dispatch = useDispatch();

    const brokerFirmsFiltered = useSelector(state => state.brokerFirms.brokerFirmsFiltered);
    const [userBrokerFirm, setUserBrokerFirm] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredOptions, setFilteredOptions] = useState([]);

    useEffect(() => {
        if (broker) {
            const selectedUserBrokerFirm = brokerFirms.find(firm => firm.id === Number(broker.brokerFirmId));
            setUserBrokerFirm(selectedUserBrokerFirm);
            setFilteredOptions(brokerFirmsFiltered);
        }
    }, [broker, brokerFirms, brokerFirmsFiltered]);


    const handleInputChange = (query) => {
        if (typeof query !== 'string') {
            query = '';
        }

        if (query?.length < 3) {
            setSearchQuery(query);
            setFilteredOptions([]);
            return;
        }
        
        dispatch(requestBrokerFirmsFiltered({ search: query.toLowerCase() }));

        setFilteredOptions(brokerFirmsFiltered);

        setSearchQuery(query);
    };

    const handleOnChange = (event) => {
        changeBroker({
            key: 'brokerFirmId',
            value: event.value,
        });
    };

    if (fetchingBroker) {
        return (
            <div className={'col-sm-12'}>
                <Loader variant="list" />
            </div>
        )
    }
    if (generalError) {
        return (
            <div className={'row'}>
                {generalError && (
                    <div className="col-sm-12 mb-15">
                        <Alert
                            variant="error"
                            label={generalError}
                        />
                    </div>
                )}
            </div>
        )
    }
    return (
        <div>
            <div className={'row'}>
                <h2 className="col-sm-12 applicationsAndPolicies-h2">
                    {broker.id ? 'Edit Broker User' : 'Create Broker User'}
                </h2>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12'}>
                    <form className={'form-horizontal'} onSubmit={handleSubmit}>
                        {broker.id && unlockErrorMessage && (
                            <div className="col-sm-12">
                                <Alert variant="error" label={unlockErrorMessage} />
                            </div>
                        )}
                        {broker.id &&
                            <div className={"form-group"}>
                                <div className={"col-sm-12"}>
                                    <Button
                                        wrapper={"btn-wrapper"}
                                        clickHandler={onUnlockBroker}
                                        variant={'tertiary'}
                                        btnStyle={'btn btn-primary btn-xs sharp blue'}
                                        label="Unlock User"
                                        arrowDirection={'right'}
                                        disabled={!(broker.isLockedOutUntilUtc
                                            && moment().isBefore(moment.utc(broker.isLockedOutUntilUtc).local()))}
                                    />
                                    {broker.isLockedOutUntilUtc
                                        && moment().isBefore(moment.utc(broker.isLockedOutUntilUtc).local()) &&
                                        <span>
                                            {`Locked until ${moment.utc(broker.isLockedOutUntilUtc).local().format("DD/MM/YYYY HH:mm:ss")}`}
                                            {unlockingUser && (
                                                [
                                                    " ",
                                                    <Loader variant="list" />
                                                ]
                                            )}
                                        </span>}
                                </div>
                            </div>}

                        <FormGroup
                            labelSize={"col-sm-3"}
                            inputSize={"col-sm-6 formGroupSelectInput-select-wrapper"}
                            label='Agency'
                            variant={"searchableList"}
                            inputProps={{
                                inputValue: searchQuery,
                                name: 'brokerFirmId',
                                onInputChange: handleInputChange,
                                onChange: handleOnChange,
                                instanceId: 'brokerFirmId',
                                value: userBrokerFirm ? { value: userBrokerFirm.id } : null,
                                options: userBrokerFirm != null && searchQuery === ''
                                    ? [{ value: userBrokerFirm.id, label: userBrokerFirm.name }]
                                    : filteredOptions.map(option => ({ value: option.id, label: option.name })),
                                isLoading: props.brokerFirms.fetchingBroker,
                                placeholder: 'Type at least 3 letters',
                                noOptionsText: 'No brokers found',
                                minSearchCharacters: 3,
                                isMulti: false,
                                required: true
                            }}
                            CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                            RightWrapper=""
                            SelectStyle={'form-control formGroupSelectInput-select'}
                        />

                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Forename"
                            variant="text"
                            inputProps={{
                                onChange: (e) => changeBroker({ key: e.target.name, value: e.target.value }),
                                name: 'forename',
                                value: broker.forename,
                                required:true,
                            }}
                        />
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Surname"
                            variant="text"
                            inputProps={{
                                onChange: (e) => changeBroker({ key: e.target.name, value: e.target.value }),
                                name: 'surname',
                                value: broker.surname,
                                required: true,
                            }}
                        />
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Email"
                            variant="text"
                            inputProps={{
                                onChange: (e) => changeBroker({ key: e.target.name, value: e.target.value }),
                                name: 'email',
                                value: broker.email,
                                required: true,
                            }}
                        />
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="CC Email Address"
                            variant="text"
                            inputProps={{
                                onChange: (e) => changeBroker({ key: e.target.name, value: e.target.value }),
                                name: 'ccEmailAddress',
                                value: broker.ccEmailAddress,
                                required: false,
                            }}
                        />
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Username"
                            variant="text"
                            inputProps={{
                                onChange: (e) => changeBroker({ key: e.target.name, value: e.target.value }),
                                name: 'username',
                                value: broker.username,
                                required: true,
                            }}
                        />
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Address"
                            variant="textarea"
                            inputProps={{
                                onChange: (e) => null,
                                name: 'address',
                                value: userBrokerFirm ? (
                                    userBrokerFirm.address
                                        .split('\n')
                                        .map((line) => line.trim())
                                        .filter((line) => line !== '')
                                        .join(' ')
                                ) + ' ' + userBrokerFirm.postcode : '',
                                required: false,
                                disabled : true
                            }}
                        />
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Telephone Number 1"
                            variant="text"
                            inputProps={{
                                onChange: (e) => changeBroker({ key: e.target.name, value: e.target.value }),
                                name: 'telephone1',
                                value: broker.telephone1,
                                required: false,
                            }}
                        />
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Telephone Number 1 Description"
                            variant="text"
                            inputProps={{
                                onChange: (e) => changeBroker({ key: e.target.name, value: e.target.value }),
                                name: 'telephone1Description',
                                value: broker.telephone1Description,
                                required: false,
                            }}
                        />
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Telephone Number 2"
                            variant="text"
                            inputProps={{
                                onChange: (e) => changeBroker({ key: e.target.name, value: e.target.value }),
                                name: 'telephone2',
                                value: broker.telephone2,
                                required: false,
                            }}
                        />
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Telephone Number 2 Description"
                            variant="text"
                            inputProps={{
                                onChange: (e) => changeBroker({ key: e.target.name, value: e.target.value }),
                                name: 'telephone2Description',
                                value: broker.telephone2Description,
                                required: false,
                            }}
                        />
                        <div className={'form-group'}>
                            <div className={'col-sm-6 col-sm-offset-3'}>
                                <Button
                                    variant={'primary'}
                                    label={broker.id ? 'Save Changes' : 'Create Broker User'}
                                    wrapper="btn-wrapper"
                                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                    arrowDirection={'right'}
                                    onClick={handleSubmit}
                                />
                                <Button
                                    variant={'quaternary'}
                                    label={'Cancel'}
                                    wrapper="btn-wrapper"
                                    btnStyle={'btn btn-primary btn-xs sharp white'}
                                    arrowDirection={'right'}
                                    onClick={cancelSubmit}
                                    style={{ marginLeft: '10px' }}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            {formSuccessMsg && (
                                <div className="col-sm-6 col-sm-offset-3">
                                    <Alert
                                        variant="success"
                                        label={formSuccessMsg}
                                    />
                                </div>
                            )}

                            {formErrors.length > 0 && (
                                <div className="col-sm-6 col-sm-offset-3">
                                    <Alert
                                        variant="error"
                                        label={formErrors.map((error, index) => (
                                            <li key={index}>{error}</li>
                                        ))}
                                    />
                                </div>
                            )}
                        </div>
                    </form>
                </div>
                {loading && (
                    <div className={'col-sm-12'}>
                        <Loader variant="list" />
                    </div>
                )}
            </div>
        </div>
    )
};

export default Broker;